var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 24 24",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22V9h5V7H4v2h5v13h2v-7h2v7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBody);
export default __webpack_public_path__ + "static/media/BiBody.6cc1c87e94ab6731a2e5e1eeec5b4909.svg";
export { ForwardRef as ReactComponent };